import { EntitySearchInputProps } from './entity-search-input.types'
import styles from './entity-search-input.module.scss'
import cl from 'classnames'
import { Text1, Input, Button, Text2, IconExpand } from '@touche-lts/panel-ui/dist'
import { useOutsideClick } from './entity-search-input.utils'
import { useState } from 'react'
import { PictureNameLine } from 'components'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const EntitySearchInputComponent = (props: EntitySearchInputProps) => {
  const {
    className,
    style,
    inputLabel,
    inputProps,
    searchResults,
    noResultsMessage,
    addNewEntityProps
  } = props

  const [showResults, setShowResults] = useState(false)
  const ref = useOutsideClick(() => setShowResults(false))
  const {isResponsive:isLargeMobile} = useGetIsResponsiveScreen('(max-width:920px)')

  return (
    <div className={cl(styles.searchContainer, className)} style={style}>
      <Text1 bold className={styles.inputLabel}>
        {inputLabel}
      </Text1>
      <div
        className={cl(styles.inputContainer, className)}
        style={style}
        ref={ref}
      >
        <Input
          placeholder='Search...'
          containerProps={{ style: { marginBottom: -35, ...(isLargeMobile && {width: "85%"})} }}
          onFocus={() => setShowResults(true)}
          {...inputProps}
        />
        {searchResults && showResults && (
          <div className={styles.resultsContainer}>
            <div className={cl(styles.body, styles.scrollable)}>
              {Boolean(!searchResults.length) && (
                <Text1 className={styles.notFoundText}>
                  {noResultsMessage}
                </Text1>
              )}
              {searchResults.map(result => {
                return (
                  <div key={result.id} className={styles.resultLine}>
                    <PictureNameLine
                      nameTextProps={{
                        className: styles.nameText
                      }}
                      {...result}
                    />
                    {result.buttonProps && (
                      <Button preset='link' {...result.buttonProps} />
                    )}
                  </div>
                )
              })}
            </div>
            {addNewEntityProps && (
              <div className={styles.body}>
                <Text2 className={styles.notFoundText}>
                  {addNewEntityProps.message ||
                    "You don't find what you are looking for?"}
                </Text2>
                <Button
                  preset='link'
                  className={styles.addUserButton}
                  onClick={addNewEntityProps.addButtonProps.onClick}
                >
                  <IconExpand />
                  {addNewEntityProps.addButtonProps.children}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

const EntitySearchInput = EntitySearchInputComponent
export { EntitySearchInput }
